import { render, staticRenderFns } from "./AdminProductNewArrival.vue?vue&type=template&id=0d4684d2"
import script from "./AdminProductNewArrival.vue?vue&type=script&lang=js"
export * from "./AdminProductNewArrival.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports